export default __webpack_public_path__ + "static/media/Profile.c3f94521.png";